module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 4);
}([function (e, t) {
  e.exports = require("@babel/runtime/regenerator");
}, function (e, t) {
  e.exports = require("deepmerge");
}, function (e, t) {
  e.exports = require("@babel/runtime/helpers/asyncToGenerator");
}, function (e, t) {
  e.exports = require("@babel/runtime/helpers/defineProperty");
}, function (e, t, r) {
  "use strict";

  r.r(t), r.d(t, "gatewayAuthHeader", function () {
    return y;
  }), r.d(t, "gatewayEmbedHostHeader", function () {
    return v;
  }), r.d(t, "setEmbedHost", function () {
    return m;
  }), r.d(t, "clearEmbedHost", function () {
    return b;
  }), r.d(t, "getEmbedHost", function () {
    return g;
  }), r.d(t, "setAPIKey", function () {
    return P;
  }), r.d(t, "clearAPIKey", function () {
    return j;
  }), r.d(t, "getAPIKey", function () {
    return O;
  }), r.d(t, "promiseTimeout", function () {
    return T;
  }), r.d(t, "get", function () {
    return x;
  }), r.d(t, "post", function () {
    return E;
  }), r.d(t, "put", function () {
    return k;
  }), r.d(t, "patch", function () {
    return C;
  }), r.d(t, "remove", function () {
    return S;
  }), r.d(t, "generateJsonRPCObject", function () {
    return A;
  }), r.d(t, "promiseRace", function () {
    return D;
  });
  var n = r(3),
      o = r.n(n),
      u = r(2),
      i = r.n(u),
      a = r(0),
      c = r.n(a),
      s = r(1),
      d = r.n(s);

  function f(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function p(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? f(Object(r), !0).forEach(function (t) {
        o()(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  var l = "torus-default",
      h = "",
      y = "x-api-key",
      v = "x-embed-host";

  function m(e) {
    h = e;
  }

  function b() {
    h = "";
  }

  function g() {
    return h;
  }

  function P(e) {
    l = e;
  }

  function j() {
    l = "torus-default";
  }

  function O() {
    return l;
  }

  function w() {
    var e = {};
    return l && (e[y] = l), h && (e[v] = h), e;
  }

  var T = function T(e, t) {
    var r = new Promise(function (t, r) {
      var n = setTimeout(function () {
        clearTimeout(n), r(new Error("Timed out in ".concat(e, "ms")));
      }, e);
    });
    return Promise.race([t, r]);
  },
      x = function () {
    var e = i()(c.a.mark(function e(t) {
      var r,
          n,
          o,
          u,
          i,
          a = arguments;
      return c.a.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return r = a.length > 1 && void 0 !== a[1] ? a[1] : {}, n = a.length > 2 && void 0 !== a[2] ? a[2] : {}, o = {
                mode: "cors",
                headers: {}
              }, n.useAPIKey && (o.headers = p(p({}, o.headers), w())), u = d.a.all([o, r, {
                method: "GET"
              }]), e.next = 7, fetch(t, u);

            case 7:
              if (!(i = e.sent).ok) {
                e.next = 10;
                break;
              }

              return e.abrupt("return", i.json());

            case 10:
              throw i;

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
      E = function E(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
        o = {
      mode: "cors",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    };
    n.useAPIKey && (o.headers = p(p({}, o.headers), w()));
    var u = d.a.all([o, r, {
      method: "POST"
    }]);
    return u.body = n.isUrlEncodedData ? t : JSON.stringify(t), void 0 === u.headers["Content-Type"] && delete u.headers["Content-Type"], T(n.timeout || 3e4, fetch(e, u).then(function (e) {
      if (e.ok) return e.json();
      throw e;
    }));
  },
      k = function k(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
        o = {
      mode: "cors",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    };
    n.useAPIKey && (o.headers = p(p({}, o.headers), w()));
    var u = d.a.all([o, r, {
      method: "PUT"
    }]);
    return u.body = n.isUrlEncodedData ? t : JSON.stringify(t), void 0 === u.headers["Content-Type"] && delete u.headers["Content-Type"], T(n.timeout || 3e4, fetch(e, u).then(function (e) {
      if (e.ok) return e.json();
      throw e;
    }));
  },
      C = function () {
    var e = i()(c.a.mark(function e(t) {
      var r,
          n,
          o,
          u,
          i,
          a,
          s = arguments;
      return c.a.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return r = s.length > 1 && void 0 !== s[1] ? s[1] : {}, n = s.length > 2 && void 0 !== s[2] ? s[2] : {}, o = s.length > 3 && void 0 !== s[3] ? s[3] : {}, u = {
                mode: "cors",
                headers: {
                  "Content-Type": "application/json; charset=utf-8"
                }
              }, o.useAPIKey && (u.headers = p(p({}, u.headers), w())), (i = d.a.all([u, n, {
                method: "PATCH"
              }])).body = o.isUrlEncodedData ? r : JSON.stringify(r), void 0 === i.headers["Content-Type"] && delete i.headers["Content-Type"], e.next = 10, fetch(t, i);

            case 10:
              if (!(a = e.sent).ok) {
                e.next = 13;
                break;
              }

              return e.abrupt("return", a.json());

            case 13:
              throw a;

            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
      S = function () {
    var e = i()(c.a.mark(function e(t) {
      var r,
          n,
          o,
          u,
          i,
          a = arguments;
      return c.a.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return a.length > 1 && void 0 !== a[1] ? a[1] : {}, r = a.length > 2 && void 0 !== a[2] ? a[2] : {}, n = a.length > 3 && void 0 !== a[3] ? a[3] : {}, o = {
                mode: "cors",
                headers: {
                  "Content-Type": "application/json; charset=utf-8"
                }
              }, n.useAPIKey && (o.headers = p(p({}, o.headers), w())), u = d.a.all([o, r, {
                method: "DELETE"
              }]), e.next = 8, fetch(t, u);

            case 8:
              if (!(i = e.sent).ok) {
                e.next = 11;
                break;
              }

              return e.abrupt("return", i.json());

            case 11:
              throw i;

            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
      A = function A(e, t) {
    return {
      jsonrpc: "2.0",
      method: e,
      id: 10,
      params: t
    };
  },
      D = function D(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 3e4;
    return Promise.race([x(e, t), new Promise(function (e, t) {
      setTimeout(function () {
        t(new Error("timed out"));
      }, r);
    })]);
  };
}]);